module.exports = __webpack_public_path__ + "img/HZGB06-15W.7fc7ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB06-15W.png
// module id = 5WxW
// module chunks = 0